import {NfMessage, NfMessageType} from "../NfMessage";
import {ReservationSearchData} from "../Models/ReservationSearchData";
import type {ShopChosenModel} from "../Models/ShopChosenModel";
import {NfComponentMessage} from "../NfComponentMessage";

/**
 * Wiadomość, gdy potrzebna jest kalkulacja kosztów rezerwacji, do service workera
 */
export class GetReservationCalculation extends NfComponentMessage {
    private serializedReservationSearchData: any;
    private serializedChosenShopData: any;
    declare public roomStandardId: number;
    declare public offerId: number;
    declare public reservationUniqueId: number;
    declare public discountId: number | null | undefined;
    public constructor(reservationSearchData: ReservationSearchData|MessageEvent<GetReservationCalculation>,
                       chosenShopData?: ShopChosenModel, offerId?: number, roomStandardId?: number,
                       discountId?: number|null, reservationUniqueId?: number) {
        super(NfMessageType.GetReservationCalculation);
        if(NfMessage.isMessageEvent(reservationSearchData)) {
            Object.assign(this, reservationSearchData.data);
        } else {
            this.serializedReservationSearchData = this.serialize(reservationSearchData);
            if(!chosenShopData) {
                throw Error('chosenShopData jest wymagany');
            }
            this.serializedChosenShopData = this.serialize(chosenShopData);
            if(!offerId) {
                throw Error('offerId jest wymagany');
            }
            this.offerId = offerId;
            if(!roomStandardId) {
                throw Error('roomStandardId jest wymagany');
            }
            this.roomStandardId = roomStandardId;
            this.discountId = discountId;
            if(!reservationUniqueId) {
                throw Error('reservationUniqueId jest wymagany');
            }
            this.reservationUniqueId = reservationUniqueId;
        }
    }
    public getChosenShopData():ShopChosenModel {
        return this.deserialize(this.serializedChosenShopData);
    }
    public getReservationSearchData(): ReservationSearchData {
        return ReservationSearchData.deserialize(this.deserialize(this.serializedReservationSearchData));
    }
}
NfMessage.creationCallbacks[NfMessageType.GetReservationCalculation] = (event) => {
    return new GetReservationCalculation(event);
}
